import { get, isEqual } from 'lodash';
import Errors from '@/modules/_global/classes/Errors';

export const CREATE = 'create';
export const EDIT = 'edit';
export const SHOW = 'show';

export const views = [CREATE, EDIT, SHOW];

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: [Errors, Object],
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: CREATE,
      validator: prop => views.includes(prop)
    }
  },

  data: () => ({
    form: {}
  }),

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  computed: {
    isCreate() {
      return this.action === CREATE;
    },
    isEdit() {
      return this.action === EDIT;
    },
    isShow() {
      return this.action === SHOW;
    }
  },

  methods: {
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.form)) {
        return;
      }

      this.form = {
        ...this.form,
        ...formProps
      };

      this.emitter();
    },

    emitter() {
      this.$emit('input', this.form);
    },

    updateValue(key, value, prefix) {
      this.updatePropWrapPrefix(key, value, prefix);
      this.emitter();
    },

    updateProp(key, value) {
      this.$emit(`update:${key}`, value);
      this.$emit('update-prop', key, value);
    },

    updatePropWrapPrefix(key, value, prefix) {
      this.updateProp(prefix ? `${prefix}.${key}` : key, value);
    },

    getRulesByName(name) {
      if (this.readonly) {
        return [];
      }

      return this.rules ? get(this.rules, name, []) : [];
    }
  }
};
